import React from "react";
import { AlertTriangle } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { Modal } from "@/components/gameplay/parts";

/**
 * Warning shown when the user clicks BACK or EXIT mid-game.
 *
 * `action` is whatever was originally requested ("back" | "exit") — we
 * surface it to the parent on confirm so it can route accordingly.
 */
export default function ConfirmExitModal({ action, onConfirm, onCancel }) {
  const { t } = useI18n();
  return (
    <Modal>
      <AlertTriangle className="w-16 h-16 mx-auto text-amber-500 mb-3" />
      <h2 className="text-2xl md:text-3xl font-[Fredoka] font-bold text-slate-900 mb-2">
        {t("exit_warning_title")}
      </h2>
      <p className="text-sm text-slate-600 mb-6">{t("exit_warning_subtitle")}</p>
      <div className="grid grid-cols-2 gap-3">
        <button
          data-testid="btn-confirm-exit-no"
          onClick={onCancel}
          className="px-4 py-3 bg-slate-200 hover:bg-slate-300 text-slate-900 rounded-full font-bold border-b-2 border-slate-400 active:translate-y-[1px] active:border-b-0"
        >
          {t("no")}
        </button>
        <button
          data-testid="btn-confirm-exit-yes"
          onClick={() => onConfirm(action)}
          className="px-4 py-3 bg-rose-500 hover:bg-rose-600 text-white rounded-full font-bold border-b-2 border-rose-700 active:translate-y-[1px] active:border-b-0"
        >
          {t("yes")}
        </button>
      </div>
    </Modal>
  );
}
